// Copyright (c) 2015, Alphamonak Solutions

if (!window.monak) window.monak = {};

monak.subscribe_to_newsletter = function (opts, btn) {
	return melon.call({
		type: "POST",
		method: "melon.email.doctype.newsletter.newsletter.subscribe",
		btn: btn,
		args: { email: opts.email },
		callback: opts.callback,
	});
};
